// src/pages/ChangePasswordPage.jsx
import React, { useState } from 'react';
import { Input, Button, Typography, Card, CardContent, Stack, Box, Link } from '@mui/joy';
import { Link as RouterLink } from 'react-router-dom';

export default function ChangePasswordPage() {
  const [username, setUsername] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChangePassword = async () => {
    setError('');
    setMessage('');

    if (!username || !oldPassword || !newPassword || !confirmPassword) {
      setError('Compila tutti i campi');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('La nuova password e la conferma non coincidono');
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_HOST}/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, oldPassword, newPassword }),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.message || 'Errore durante il cambio password');
      }

      setMessage('Password cambiata con successo!');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Card sx={{ maxWidth: 400, mx: 'auto', mt: 10, p: 3 }}>
      <CardContent>
        <Stack spacing={3}>
          {/* Logo e scritta */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
            <img
              src={`${process.env.REACT_APP_SERVER_HOST}/assets/img/logo/SEM.svg`}
              alt="Logo SEM"
              style={{ width: 40, height: 40 }}
            />
            <Typography component="h1" level="h5">
              SEM - Admin
            </Typography>
          </Box>

          {/* Titolo e sottotitolo */}
          <Box>
            <Typography level="h4">Benvenuto su SEM 🚑</Typography>
            <Typography level="body-sm" color="neutral">
              Cambia la tua password
            </Typography>
          </Box>

          {/* Form */}
          <Input
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Input
            type="password"
            placeholder="Password attuale"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            autoComplete="current-password"
          />
          <Input
            type="password"
            placeholder="Nuova password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoComplete="new-password"
          />
          <Input
            type="password"
            placeholder="Conferma nuova password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
          />
          {error && (
            <Typography color="danger" level="body-sm">
              {error}
            </Typography>
          )}
          {message && (
            <Typography color="success" level="body-sm">
              {message}
            </Typography>
          )}
          <Button onClick={handleChangePassword}>Cambia password</Button>
          <Box sx={{ textAlign: 'center' }}>
              <Link component={RouterLink} to="/" level="body-sm">
                Login
              </Link>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
